import { proxy } from 'valtio'
import { openMemberUpgradeDialog } from '../lib/member-upgrade-store';

export interface MaterialSpaceInfo {
    space_total: number;
    space_expire_ts: number;
    space_used: number;
    project_material_size: number;
}

export const spaceStore = proxy({
    spaceInfo: null as MaterialSpaceInfo | null,
})

export function setSpaceInfo(info: MaterialSpaceInfo) {
    if (!spaceStore.spaceInfo) {
        spaceStore.spaceInfo = info;
    } else {
        Object.assign(spaceStore.spaceInfo, info);
    }
}

/**
 * 检查空间是否足够
 * @param space
 * @returns
 */
export function checkSpaceEnough() {
    if (!spaceStore.spaceInfo) return true;
    if (spaceStore.spaceInfo.space_used >= spaceStore.spaceInfo.space_total) {
        openMemberUpgradeDialog({ message: "空间不足，请清理项目和资产，如需扩容存储空间，请升级会员获取。" })
        return false;
    }
    return true;
}